export const darkTheme = {
    bg:"#091618",
    bgLight: "#EC7063",
    primary: "#D68910", // done
    text_primary:"#F2F3F4",
    text_secondary:"#b1b2b3",
    card:"#091618",
    card_light: '#17202A ',// to be change    ----- done
    button:"#067A75",
    white:"#FFFFFF",
    black:"#000000",
}

export const lightTheme = {
    bg:"#FFFFFF",
    bgLight: "#EC7063",
    primary:"#be1adb",
    text_primary:"#111111",
    text_secondary:"#48494a",
    card:"#FFFFFF",
    button:"#091618",
}